"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Facebook = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Facebook = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "facebook", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "facebook", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M30.222 0H1.765C.79 0 0 .78 0 1.744V29.85c0 .963.79 1.744 1.765 1.744h15.32V19.359h-4.168V14.59h4.168v-3.517c0-4.08 2.524-6.302 6.21-6.302 1.765 0 3.282.13 3.724.188v4.264l-2.556.001c-2.004 0-2.392.941-2.392 2.322v3.044h4.78l-.622 4.768H22.07v12.235h8.15c.976 0 1.766-.781 1.766-1.744V1.744A1.752 1.752 0 0 0 30.222 0", fillRule: "evenodd" }) })) })));
};
exports.Facebook = Facebook;
